export const AI_WORK_EXPERIENCE_RESULT_MODAL = 'aiWorkExperienceResultModal'
export const DIALOG_ANALYTICS_LABEL = 'ai_suggestion_dialog'
